import { useNavigate } from 'react-router'
import { PhoneOutlined } from '@mui/icons-material'
import { Button, Grid, Typography } from '@mui/material'
import { Formik } from 'formik'
import * as Yup from 'yup'

import FormikDropdown from '../../../components/formik-dropdown'
import FormikTextField from '../../../components/formik-input'
import { useHspPlusContext } from '../../../providers/hsp-plus-provider'
import { isValidPhoneNumber } from '../../../utils/helpers'
import useIsMobile from '../../../utils/hooks/useIsMobile'
import useStyles from '../shared.styles'

const phoneTypes = [
  { id: 'Mobile Phone', name: 'Mobile Phone' },
  { id: 'Landline', name: 'Landline' },
]

const validationSchema = Yup.object({
  email: Yup.string().trim().email('Enter a valid email').required('Email is required'),
  mobileNumber: Yup.string()
    .trim()
    .required('Phone number is required')
    .test('valid-phone', 'Enter a valid phone number', (value) => isValidPhoneNumber(value)),
  phoneType: Yup.string().required('Phone type is required'),
})

const HSPContactInformation = () => {
  const isMobile = useIsMobile()
  const classes = useStyles
  const navigate = useNavigate()
  const { values, setValues } = useHspPlusContext()

  return (
    <Formik
      initialValues={{ email: values.email, mobileNumber: values.mobileNumber, phoneType: values.phoneType }}
      enableReinitialize={true}
      onSubmit={(formValues) => {
        setValues(formValues)
        navigate('/hsp-plus/otp')
      }}
      validationSchema={validationSchema}
      validateOnMount={true}
    >
      {({ handleSubmit, isSubmitting, isValid }) => (
        <Grid container={true} component="form" onSubmit={handleSubmit} sx={classes.screen(isMobile)}>
          <Grid container={true} sx={classes.form}>
            <Grid container={true} sx={classes.intro(isMobile)}>
              <Typography component="h1" variant="h5" color="textSecondary" sx={classes.title}>
                Almost there!
              </Typography>
              <Typography variant="body2">Just a few details left to create your account</Typography>
            </Grid>

            <Grid container={true} sx={classes.fields(isMobile)}>
              <Grid size={12}>
                <FormikTextField name="email" label="Email" variant="filled" slotProps={{ htmlInput: { inputMode: 'email' } }} />
              </Grid>
              <Grid size={12}>
                <FormikTextField name="mobileNumber" label="Phone Number" variant="filled" slotProps={{ htmlInput: { inputMode: 'tel' } }} />
              </Grid>
              <Grid size={12}>
                <FormikDropdown
                  name="phoneType"
                  label="Type"
                  required={false}
                  variant="filled"
                  size="medium"
                  items={phoneTypes}
                  startAdornment={<PhoneOutlined />}
                />
              </Grid>
            </Grid>

            <Grid container={true} sx={classes.submitContainer}>
              <Button type="submit" variant="contained" size="large" disableElevation disabled={!isValid || isSubmitting}>
                Complete registration
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Formik>
  )
}

export default HSPContactInformation
